module.exports = __webpack_public_path__ + "img/Footer_3624.89d830cd.jpg";